export enum FontSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xlg = 'xlg',
}
